module.exports = __webpack_public_path__ + "img/BLANCO_Acompañamiento.47641c66.png";